import React from "react";

const QuestionBankIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="63.067"
      height="41.562"
      viewBox="0 0 63.067 41.562"
    >
      <g id="db27" transform="translate(0 0)">
        <path
          id="Path_1247"
          data-name="Path 1247"
          d="M15.317,972.362a3.517,3.517,0,0,0-3.583,3.464V977.9H69.067v-2.078a3.517,3.517,0,0,0-3.583-3.464Zm-3.583,8.313v4.156H69.067v-4.156Zm0,6.927v6.343a11.733,11.733,0,0,1,4.3-.8A11.3,11.3,0,0,1,27.5,1004.226a10.685,10.685,0,0,1-.829,4.156H65.484a3.517,3.517,0,0,0,3.583-3.464V987.6H11.733Zm40.134,4.849a5.847,5.847,0,0,1,3.583,1.234,5.831,5.831,0,0,1,3.583-1.234,5.545,5.545,0,1,1,0,11.083,5.808,5.808,0,0,1-3.583-1.234,5.847,5.847,0,0,1-3.583,1.234,5.545,5.545,0,1,1,0-11.083Zm-35.834,2.078a9.7,9.7,0,1,0,0,19.4,9.7,9.7,0,1,0,0-19.4Zm35.834.693a2.772,2.772,0,1,0,2.867,2.771A2.8,2.8,0,0,0,51.867,995.221Zm7.167,0a2.927,2.927,0,0,0-1.859.671,5.393,5.393,0,0,1,0,4.2,2.891,2.891,0,0,0,1.859.671,2.772,2.772,0,1,0,0-5.542Zm-43,.693c2.478,0,4.658,1.707,4.658,4a5.715,5.715,0,0,1-2.128,4.546c-.9.8-1.456,1.1-1.456,2.879a1.075,1.075,0,0,1-2.15,0,5.567,5.567,0,0,1,2.128-4.416,3.122,3.122,0,0,0,1.456-3.009,2.267,2.267,0,0,0-2.508-1.927c-1.385,0-2.345.607-2.531,1.364a1.12,1.12,0,0,1-1.3.779,1.1,1.1,0,0,1-.806-1.277C11.879,996.9,13.957,995.914,16.033,995.914Zm0,13.854a1.386,1.386,0,1,1-1.433,1.385A1.41,1.41,0,0,1,16.033,1009.768Z"
          transform="translate(-6 -972.362)"
          fill={fill ? fill : "#1eb942"}
        />
      </g>
    </svg>
  );
};

export default QuestionBankIcon;
